import { styled } from '@mui/material/styles';
import { breakpoints } from '../../theme';

export const HomeWrapper = styled('div')`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    align-items: center;
  }
`;

export const InnerWrapper = styled('div')`
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.colors.neutral.shades.shade200}`};
  padding: 40px;
  margin-top: 24px;
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
`;

export const Card = styled('div')`
  margin-top: 24px;
  display: flex;
  padding: 24px;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.neutral.shades.shade100};
`;

export const CardElement = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;

  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ButtonGroup = styled('div')`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;
